import React, { useCallback } from "react";
import Layout, { LAYOUT_QUERY } from "@/components/Layout";

import { RootState } from "@/store/store";
import { RADIO_STATE } from "@/store/liveRadio/action";
import { connect } from "react-redux";
import { compose } from "redux";

import Link from "next/link";
import { GRAPHQL_STRAPI_IMAGE } from "@/components/StrapiProgressiveImage";
import { StrapiImage } from "typings/strapi";

import { Avatar, List, Pagination, Typography } from "antd";

import { useRouter } from "next/router";

require("@/styles/blog.less");

export const GET_BLOG_POSTS_QUERY = (pageNumber: number) => `
query GetBlogPosts {
  ${LAYOUT_QUERY}
  articles(sort: "published_at:desc", limit: ${ITEMS_PER_PAGE}, start:${
  (pageNumber - 1) * ITEMS_PER_PAGE
}) {
    title
    slug
    Cover {
      ${GRAPHQL_STRAPI_IMAGE}
    }
    ArticleContent {
      __typename
      ... on ComponentArticleContentRichText {
        Content
      }
    }
    author {
      username
      profilePicture {
        ${GRAPHQL_STRAPI_IMAGE}
      }
    }
  }
  articlesConnection {
    aggregate {
          totalCount
        }
  }
}
`;

export const TOTAL_BLOG_POST_PAGE_COUNT_QUERY = `
query GetTotalCountBlogPages {
  articlesConnection {
    aggregate {
        totalCount
      }
  }
}
`;

const ITEMS_PER_PAGE = 10;

export interface ComponentArticleContentRichText {
  Content: string;
  __typename: "ComponentArticleContentRichText";
}
export interface ArticleData {
  Cover: StrapiImage;
  title: string;
  slug: string;
  ArticleContent: ComponentArticleContentRichText[];
  author: {
    username: string;
    profilePicture: StrapiImage;
    biography: string;
  };
}

const { Title } = Typography;

const BlogPage: React.FC<{
  graphQLData: any;
  totalPageNum: number;
  currentPageNum: number;
}> = ({ graphQLData, totalPageNum, currentPageNum }) => {
  // const { data, loading, error } = useQuery(JOIN_PURPLE_QUERY);

  // if (loading) return <p>Loading...</p>;
  // if (error) return <p>Error: {JSON.stringify(error)}</p>;

  const router = useRouter();
  const navigateNewPage = useCallback(
    (pageNum) => {
      // don't navigate if already on page
      if (pageNum !== currentPageNum) {
        router.push(`/blog/${encodeURIComponent(Number(pageNum))}`);
      }
    },
    [router, currentPageNum]
  );

  const articles: ArticleData[] = graphQLData?.articles;

  return (
    <Layout data={graphQLData} title={"Blogs"}>
      <div className="blog-page">
        <Title>Blog</Title>
        <List
          itemLayout="horizontal"
          dataSource={articles}
          renderItem={(item) => (
            <Link href={"/posts/" + item.slug}>
              <List.Item>
                <List.Item.Meta
                  avatar={
                    <Avatar
                      size={64}
                      src={
                        item?.Cover?.formats?.logo?.url ||
                        "/assets/logo-purple-circle.png"
                      }
                    />
                  }
                  title={<Link href={"/posts/" + item.slug}>{item.title}</Link>}
                  description={
                    (item?.ArticleContent[0]?.Content || "")
                      .replace(/[#*_]/g, "")
                      .slice(0, 120) + "..."
                  }
                />
              </List.Item>
            </Link>
          )}
        />
        <div className={"pagination"}>
          <Pagination
            current={currentPageNum}
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} of ${total} items`
            }
            total={ITEMS_PER_PAGE * totalPageNum}
            onChange={navigateNewPage}
            showSizeChanger={false}
          />
        </div>
      </div>
    </Layout>
  );
};

const mapState = (state: RootState) => ({
  playing: state.liveRadio.state === RADIO_STATE.PLAYING,
});

const connector = connect(mapState);

export default compose(connector)(BlogPage);
